import BorderColorIcon from "@mui/icons-material/BorderColor";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import EditNoteIcon from "@mui/icons-material/EditNote";
import EditOffIcon from "@mui/icons-material/EditOff";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import LibraryAddCheckIcon from "@mui/icons-material/LibraryAddCheck";
import React from "react";
import Widget from "../widget/Widget";

export const TopWidgetsStudentsProgress = ({ schoolData }) => {
  const totalStudents = Intl.NumberFormat("en-US", {
    notation: "compact",
    compactDisplay: "short",
  }).format(schoolData.Total_students);
  const totalAttemptedExercises = Intl.NumberFormat("en-US", {
    notation: "compact",
    compactDisplay: "short",
  }).format(schoolData.Total_attempted_exercises);

  const totalNotStartedExercises = Intl.NumberFormat("en-US", {
    notation: "compact",
    compactDisplay: "short",
  }).format(schoolData.Total_notStarted_exercises);

  const totalStartedExercises = Intl.NumberFormat("en-US", {
    notation: "compact",
    compactDisplay: "short",
  }).format(schoolData.Total_started_exercises);

  const totalStrugglingExercises = Intl.NumberFormat("en-US", {
    notation: "compact",
    compactDisplay: "short",
  }).format(schoolData.Total_struggling_exercises);

  const totalCompletedExercises = Intl.NumberFormat("en-US", {
    notation: "compact",
    compactDisplay: "short",
  }).format(schoolData.Total_completed_exercises);

  return (
    <div className="top-widget-student-progress-container flex flex-wrap gap-4 mt-4 mb-4">
      <Widget
        title="Students"
        number={totalStudents}
        icon={
          <Diversity3Icon
            className="icon"
            style={{
              backgroundColor: "#F3E5F5",
              color: "#8E24AA",
              fontSize: "2.5rem",
            }}
          />
        }
      />
      <Widget
        title="Attempted exercises"
        number={totalAttemptedExercises}
        icon={
          <BorderColorIcon
            className="icon"
            style={{
              backgroundColor: "#FFF3E0",
              color: "#FB8C00",
              fontSize: "2.5rem",
            }}
          />
        }
      />
      <Widget
        title="Exercises not started"
        number={<p style={{ color: "#eab80f" }}>{totalNotStartedExercises}</p>}
        icon={
          <EditOffIcon
            className="icon"
            style={{
              backgroundColor: "#eab80f",
              color: "white",
              fontSize: "2.5rem",
            }}
          />
        }
      />
      <Widget
        title="Total exercises started"
        number={
          <p style={{ color: "rgb(15,158,234)" }}>{totalStartedExercises}</p>
        }
        icon={
          <EditNoteIcon
            className="icon"
            style={{
              backgroundColor: "rgb(15,158,234)",
              color: "white",
              fontSize: "2.5rem",
            }}
          />
        }
      />
      <Widget
        title="Struggling exercises"
        number={<p style={{ color: "#ea271a" }}>{totalStrugglingExercises}</p>}
        icon={
          <FitnessCenterIcon
            className="icon"
            style={{
              backgroundColor: "#ea271a",
              color: "white",
              fontSize: "2.5rem",
            }}
          />
        }
      />
      <Widget
        title="Exercises completed"
        number={<p style={{ color: "#1b9808" }}>{totalCompletedExercises}</p>}
        icon={
          <LibraryAddCheckIcon
            className="icon"
            style={{
              backgroundColor: "rgba(0, 128, 0, 0.2)",
              color: "green",
              fontSize: "2.5rem",
            }}
          />
        }
      />
    </div>
  );
};
